import { Redirect, Session } from 'smg/customer-api/session';
import * as shippingoptions from 'smg/customer-api/shippingoptions';
import * as models from 'smg/customer-api/models';
import * as phone from 'smg/phone';
import * as template from 'smg/template';
import * as toast from 'smg/toast';
import { CheckPOBoxAddress, Draw, PromptNew } from '../shippingoptions';

void main();

async function main() {
    if (await Redirect()) {
        return;
    }
    const user = await Session().then(s => s.user);
    const cardContainer = document.querySelector<HTMLElement>('#shipping-options-container');

    const newAddressBtn = document.querySelector('#new-address');
    newAddressBtn?.addEventListener('click', () => {
        void PromptNew(user).then(resp => drawAddress(models.ShippingOption.fromJSON(resp)));
    });

    const { shippingOptions } = await shippingoptions.ShippingOptions({
        'data': 'address',
        'sort': 'created asc',
        'q': 'has:email has:phone has:fullName has:addressLine1 has:city has:countryID has:zip',
    });

    const drawAddress = async (optionInit: models.IShippingOption) => {
        let option = new models.ShippingOption(optionInit);
        let optionAddress = option.address;
        if (!optionAddress) {
            return;
        }
        const addressEl = await Draw(option);
        const cardEl = template.Clone('#card-template').firstElementChild as HTMLElement;
        const addressContainer = cardEl.querySelector('.address-container') as HTMLElement;
        const editBtn = cardEl.querySelector('.edit-btn');
        const deleteBtn = cardEl.querySelector('.delete-btn');

        addressContainer?.append(addressEl as HTMLElement);

        // Checkout drops options whose stored phone fails the server tel validator; let the customer fix it here.
        const applyInvalidPhoneNote = () => {
            addressContainer?.querySelector('.invalid-phone-note')?.remove();
            if (!phone.IsValid(option.address?.phoneNumber?.phone ?? '')) {
                addressContainer?.append(phone.InvalidPhoneNote());
            }
        };
        applyInvalidPhoneNote();

        editBtn?.addEventListener('click', async () => {
            const newOption = models.ShippingOption.fromJSON(await PromptNew(user, option));
            option = newOption;
            optionAddress = newOption.address;
            if (!optionAddress) {
                return;
            }
            const res = await Draw(newOption, addressEl as HTMLElement);
            applyInvalidPhoneNote();
            void CheckPOBoxAddress(optionAddress.countryID as models.CountryID, optionAddress.stateID || 0, optionAddress.addressLine1 || '', res);
        });

        deleteBtn?.addEventListener('click', () => {
            void shippingoptions.DeleteShippingOption(option.id || '').
                then(() => {
                    cardEl.parentElement?.removeChild(cardEl);
                    toast.Undo('Removed shipping option.', () => shippingoptions.RestoreShippingOption(option.id || '').then(() => drawAddress(option)));
                });
        });
        // Saving an address the customer already has returns that row, so its card is replaced, not repeated.
        cardEl.dataset.shippingOptionId = option.id ?? '';
        cardContainer?.querySelector(`[data-shipping-option-id="${CSS.escape(option.id ?? '')}"]`)?.remove();
        cardContainer?.insertBefore(cardEl, cardContainer.firstChild);
        void CheckPOBoxAddress(optionAddress.countryID as models.CountryID, optionAddress.stateID || 0, optionAddress.addressLine1 || '', addressEl as HTMLElement);
    };

    for (const shippingOption of shippingOptions) {
        await drawAddress(shippingOption);
    }
}